export const theme = {
    colors: {
        primary: '#008080',
    },

    breakpoints: {
        mobile: '767px',
    },
};